import React from 'react'
import PropTypes from 'prop-types'

const GalleryPreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()
  const image = getAsset(data.image)

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <span
          style={{
            display: 'inline-block',
            padding: '0.25rem 0.75rem',
            backgroundColor: '#48c774',
            color: 'white',
            borderRadius: '4px',
            fontSize: '0.875rem',
            fontWeight: '600',
            marginBottom: '0.5rem'
          }}
        >
          {data.category}
        </span>
        {data.featured && (
          <span
            style={{
              display: 'inline-block',
              padding: '0.25rem 0.75rem',
              backgroundColor: '#ffdd57',
              color: '#363636',
              borderRadius: '4px',
              fontSize: '0.875rem',
              fontWeight: '600',
              marginLeft: '0.5rem'
            }}
          >
            ⭐ Featured
          </span>
        )}
      </div>

      <h1 style={{
        fontSize: '2rem',
        fontWeight: '700',
        marginBottom: '0.5rem',
        color: '#363636'
      }}>
        {data.title}
      </h1>

      <p style={{
        color: '#757575',
        fontSize: '0.875rem',
        marginBottom: '1.5rem'
      }}>
        {data.date && new Date(data.date).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
      </p>

      {image && (
        <div style={{
          marginBottom: '1.5rem',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          <img
            src={image.toString()}
            alt={data.title}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
        </div>
      )}

      <p style={{
        fontSize: '1.125rem',
        lineHeight: '1.75',
        color: '#4a4a4a'
      }}>
        {data.description}
      </p>
    </div>
  )
}

GalleryPreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default GalleryPreview
